import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DailyNewsSuggestionsManager from '../../../services/daily-news-suggestions-manager';

import DailyNewsArticleBox from '../daily-news-article-box';
import dailyNewsService from '../../../services/daily-news';
import LoadingIndication from '../../common/loading-indicator';
import './daily-news-suggestions.css';

class DailyNewsSuggestions extends Component {
  constructor(props) {
    super(props);

    this.suggestionManager = new DailyNewsSuggestionsManager();
    this.state = {
      isLoading: true,
      isError: false
    };
  }
  
  componentDidMount() {
    dailyNewsService.getNews(1, this.props.tag)
      .then(dailyNewsResponse => {
        this.setState({
          isLoading: false,
          isError: false,
          suggestions: this.suggestionManager.getSuggestions(dailyNewsResponse.news),          
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isError: true
        });        
      });
  }
  
  render() {
    if (this.state.isLoading) {
      return (
        <section className='daily-news-suggestions'>
          <LoadingIndication />
        </section>
      );
    }

    if (this.state.isError) {
      return (
        <section className='daily-news-suggestions'>
          <div>Suggestions not found</div>
        </section>
      );
    }

    if (this.state.suggestions && this.state.suggestions.length === 0) return <span />;

    const dailyNewsArticlesJSX = this.state.suggestions.map((dailyNewsArticle) => 
      <DailyNewsArticleBox key={dailyNewsArticle._id} {...dailyNewsArticle} />
    );

    return (
      <section className='daily-news-suggestions'>
        <h3 className='page-title'>SUGGESTIONS</h3>
        <hr className='title-separator' />

        <div className='suggested-daily-news'>
          {dailyNewsArticlesJSX}
        </div>
      </section>
    );
  }
}

DailyNewsSuggestions.propTypes = {
  tag: PropTypes.string.isRequired,
};

export default DailyNewsSuggestions;